/* -----------------------------------------------
/* How to use? : Check the GitHub README
/* ----------------------------------------------- */

/* Otherwise just put the config content (json): */



window.addEventListener('load', (event) => {

    const particlesBg = document.getElementById("particles-bg");
    // const particlesEle = document.getElementById("particles");    
    if (particlesBg)
    {
        if (particlesBg.complete)
        {
            // console.log('aaaa');
            loadParticles();
        } else {
            // console.log('bbbb');
            particlesBg.addEventListener('load', loadParticles)
        }

    }
});


async function loadParticles()
{
    const particlesEle = document.getElementById("particles");    

    if(particlesEle)
    {
        // console.log('cccc');
        particlesJS('particles',
        {
            "particles": {
            "number": {
                "value": 80,
                "density": {
                "enable": true,
                "value_area": 800
                }
            },
            "color": {
                "value": "#ffffff"
                // "value": "rgba(44,183,193, 0.5)"
            },
            "shape": {
                "type": "circle",
                "stroke": {
                "width": 0,
                "color": "#000000"
                },
                "polygon": {
                "nb_sides": 5
                },
                "image": {
                "src": "img/github.svg",
                "width": 100,
                "height": 100
                }
            },
            "opacity": {
                "value": 0.2,
                "random": false,
                "anim": {
                "enable": false,
                "speed": 1,
                "opacity_min": 0.1,
                "sync": false
                }
            },
            "size": {
                "value": 2,
                "random": false,
                "anim": {
                "enable": false,
                "speed": 40,
                "size_min": 0.1,
                "sync": false
                }
            },
            "line_linked": {
                "enable": true,
                "distance": 180,
                "color": "#ffffff",
                "opacity": 0.2,
                "width": 1
            },
            "move": {
                "enable": true,
                "speed": 3,
                "direction": "none",
                "random": false,
                "straight": false,
                "out_mode": "bounce",
                "attract": {
                "enable": false,
                "rotateX": 600,
                "rotateY": 1200
                }
            }
            },
            "interactivity": {
            "detect_on": "canvas",
            "events": {
                "onhover": {
                    "enable": true,
                    "mode": "grab"
                },
                "onclick": {
                    "enable": false,
                    "mode": "push"
                },
                "resize": true
            },
            "modes": {
                "grab": {
                "distance": 400,
                "line_linked": {
                    "opacity": 1
                }
                },
                "bubble": {
                "distance": 400,
                "size": 40,
                "duration": 2,
                "opacity": 8,
                "speed": 3
                },
                "repulse": {
                "distance": 200
                },
                "push": {
                "particles_nb": 4
                },
                "remove": {
                "particles_nb": 2
                }
            }
            },
            "retina_detect": true,
            "config_demo": {
            "hide_card": false,
              "background_color": "#b61924",
            // "background_color": "transparent",
            "background_image": "",
            "background_position": "50% 50%",
            "background_repeat": "no-repeat",
            "background_size": "cover"
            }
        }

        );
    }
}